import {NgModule} from '@angular/core';
import {PresetWarningDialogComponent} from './preset-warning-dialog/preset-warning-dialog.component';
import {MasterDisclaimerDialogComponent} from './master-disclaimer-dialog/master-disclaimer-dialog.component';
import {GroupSetupComponent} from './group-setup/group-setup.component';
import {SharedComponentsModule} from '../../../shared-components-module/shared-components.module';
import { MaterialModule } from 'src/app/shared-components-module/material.module';


@NgModule({
    declarations: [
        GroupSetupComponent,
        PresetWarningDialogComponent,
        MasterDisclaimerDialogComponent
    ],
    exports: [
        GroupSetupComponent,
    ],
    imports: [
        SharedComponentsModule,
        MaterialModule
    ]
})
export class CriminalGridDialogsModule {
}
